module.exports = __webpack_public_path__ + "static/media/mailnews_15.d26654b8.ico";